import { useMotionValueEvent, useScroll } from 'framer-motion';
import { type RefObject, useState } from 'react';

const useIsScrolledToBottomOfRef = (
  elementRef: RefObject<HTMLElement | null>,
): boolean => {
  const [isScrolledToRef, setIsScrolledToRef] = useState<boolean>(false);
  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, 'change', () => {
    const rect = elementRef.current?.getBoundingClientRect();
    if (rect?.bottom != null && window.innerHeight >= rect.bottom) {
      if (!isScrolledToRef) {
        setIsScrolledToRef(true);
      }
    } else {
      if (isScrolledToRef) {
        setIsScrolledToRef(false);
      }
    }
  });

  return isScrolledToRef;
};

export default useIsScrolledToBottomOfRef;
